import classNames from 'classnames';

type IconProps = {
  className?: string;
} & any;

export default function IdentifiersBundleIcon({
  className,
  ...props
}: IconProps) {
  return (
    <svg
      width="84"
      height="24"
      viewBox="0 0 84 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      className={classNames('stroke-current fill-current stroke-0', className)}
      {...props}
    >
      <rect
        x="43"
        y="3"
        width="10"
        height="17"
        rx="2"
        stroke="currentColor"
        stroke-width="2"
      />
      <path d="M42 15.1916H48H54" stroke="currentColor" stroke-width="2" />
      <line
        x1="42"
        y1="7.16304"
        x2="54"
        y2="7.16304"
        stroke="currentColor"
        stroke-width="2"
      />
      <ellipse cx="48" cy="17.7731" rx="0.6" ry="0.64538" fill="currentColor" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5ZM4.09132 6.58194C4.24961 6.23843 4.59696 6 5 6H19C19.403 6 19.7504 6.23843 19.9087 6.58194L12.6139 12.2556C12.2528 12.5365 11.7472 12.5365 11.3861 12.2556L4.09132 6.58194ZM4 9.04464V14.865L7.61261 11.8544L4 9.04464ZM4.0829 17.3993C4.23705 17.7529 4.58966 18 5 18H19C19.4103 18 19.763 17.7529 19.9171 17.3993L14.7715 13.1113L13.8418 13.8343C12.7585 14.6769 11.2415 14.6769 10.1582 13.8343L9.22853 13.1113L4.0829 17.3993ZM20 14.865V9.04464L16.3874 11.8544L20 14.865Z"
        fill="currentColor"
      />
      <path
        d="M35.5 12.4167H33.4167V14.5C33.4167 14.7292 33.2292 14.9167 33 14.9167C32.7708 14.9167 32.5833 14.7292 32.5833 14.5V12.4167H30.5C30.2708 12.4167 30.0833 12.2292 30.0833 12C30.0833 11.7708 30.2708 11.5833 30.5 11.5833H32.5833V9.49999C32.5833 9.27083 32.7708 9.08333 33 9.08333C33.2292 9.08333 33.4167 9.27083 33.4167 9.49999V11.5833H35.5C35.7292 11.5833 35.9167 11.7708 35.9167 12C35.9167 12.2292 35.7292 12.4167 35.5 12.4167Z"
        fill="currentColor"
      />
      <path
        d="M63.5 12.4167H61.4167V14.5C61.4167 14.7292 61.2292 14.9167 61 14.9167C60.7708 14.9167 60.5833 14.7292 60.5833 14.5V12.4167H58.5C58.2708 12.4167 58.0833 12.2292 58.0833 12C58.0833 11.7708 58.2708 11.5833 58.5 11.5833H60.5833V9.49999C60.5833 9.27083 60.7708 9.08333 61 9.08333C61.2292 9.08333 61.4167 9.27083 61.4167 9.49999V11.5833H63.5C63.7292 11.5833 63.9167 11.7708 63.9167 12C63.9167 12.2292 63.7292 12.4167 63.5 12.4167Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.1005 16L77 20.8995L81.8995 16H81.899C80.6364 17.2372 78.9073 18 77 18C75.0927 18 73.3636 17.2372 72.101 16H72.1005Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77 18C80.866 18 84 14.866 84 11C84 7.13401 80.866 4 77 4C73.134 4 70 7.13401 70 11C70 14.866 73.134 18 77 18ZM77 16.5C80.0376 16.5 82.5 14.0376 82.5 11C82.5 7.96243 80.0376 5.5 77 5.5C73.9624 5.5 71.5 7.96243 71.5 11C71.5 14.0376 73.9624 16.5 77 16.5Z"
        fill="currentColor"
      />
      <rect x="75" y="8.5" width="1" height="5" rx="0.5" fill="currentColor" />
      <rect x="77" y="8.5" width="1" height="5" rx="0.5" fill="currentColor" />
      <path
        d="M77.5 9H78.5H78.6464C78.8728 9 79.0899 9.08993 79.25 9.25V9.25C79.4101 9.41007 79.5 9.62718 79.5 9.85355V10V10.1464C79.5 10.3728 79.4101 10.5899 79.25 10.75V10.75C79.0899 10.9101 78.8728 11 78.6464 11H78.5H77.5"
        stroke="currentColor"
      />
    </svg>
  );
}
